import has from 'lodash/has';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

const getTableRowValue = data => {
    const { header, item, value } = data;

    if (has(header, 'transform') && isFunction(header.transform)) {
        return header.transform({ header, item, value });
    }

    if (has(item, header.path)) {
        return get(item, header.path);
    }

    return value;
};

export default getTableRowValue;
